export const MenuType = Object.freeze({
  DOCUMENT: "DOCUMENT",
  TECH_DOCUMENT: "TECH_DOCUMENT",
  CATEGORY: "CATEGORY",
  USER: "USER",
  FEEDBACK: "FEEDBACK",
  POPUP_SETTING: "POPUP_SETTING"
});

export type MENU_TYPE = keyof typeof MenuType;

export const getMenuTypeLangKey = (value: string) => {
  switch (value) {
    case MenuType.DOCUMENT:
      return 'I18N_MENU_TYPE_DOCUMENT';
    case MenuType.TECH_DOCUMENT:
      return 'I18N_MENU_TYPE_TECH_DOCUMENT';
    case MenuType.CATEGORY:
      return 'I18N_MENU_TYPE_CATEGORY';
    case MenuType.USER:
      return 'I18N_MENU_TYPE_USER';
    case MenuType.FEEDBACK:
      return 'I18N_MENU_TYPE_FEEDBACK';
    case MenuType.POPUP_SETTING:
      return 'I18N_MENU_TYPE_POPUP_SETTING';
    default:
      return '';
  }
};


